module.exports = __webpack_public_path__ + "img/9788996403609.b9d1729d.jpg";